import styled from 'styled-components'


export const SC_PullContainer = styled.div`
  min-height: 100%;
  position: relative;
  transition: transform 0.2s cubic-bezier(0, 0, 0.31, 1);
`

export const SC_PullIndicator = styled.div<{ $height: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $height }) => $height}px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-100%);
  z-index: 100;
`
